/* dealkart theme scripts — hero slider, drawers, AJAX cart */
(function () {
  'use strict';

  const money = (cents) => {
    const fmt = (window.moneyFormat || '${{amount}}');
    const amount = (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  /* ---------------------------------------------------------- hero slider */
  document.querySelectorAll('[data-hero]').forEach((hero) => {
    const slides = Array.from(hero.querySelectorAll('.hero__slide'));
    const dots = Array.from(hero.querySelectorAll('.hero__dot'));
    if (slides.length < 1) return;
    let index = 0;
    let timer = null;

    const show = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    };

    hero.querySelector('[data-hero-prev]')?.addEventListener('click', () => show(index - 1));
    hero.querySelector('[data-hero-next]')?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot, n) => dot.addEventListener('click', () => show(n)));

    const autoplay = hero.dataset.autoplay === 'true';
    const speed = parseInt(hero.dataset.speed || '5', 10) * 1000;
    const start = () => { if (autoplay && slides.length > 1) timer = setInterval(() => show(index + 1), speed); };
    const stop = () => timer && clearInterval(timer);
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    show(0);
    start();
  });

  /* --------------------------------------------------------- menu drawer */
  const menu = document.getElementById('MenuDrawer');
  document.querySelectorAll('[data-menu-open]').forEach((b) =>
    b.addEventListener('click', () => menu && (menu.hidden = false))
  );
  document.querySelectorAll('[data-menu-close]').forEach((b) =>
    b.addEventListener('click', () => menu && (menu.hidden = true))
  );

  /* --------------------------------------------------------- cart drawer */
  const drawer = document.getElementById('CartDrawer');
  const drawerBody = drawer ? drawer.querySelector('[data-cart-body]') : null;

  const renderCart = (cart) => {
    if (!drawerBody) return;
    if (!cart.item_count) {
      drawerBody.innerHTML = '<p class="empty-state">Your cart is empty.</p>';
      return;
    }
    const lines = cart.items.map((item) => `
      <div class="cart-line">
        <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''}" alt="" width="92" height="92" loading="lazy">
        <div>
          <a href="${item.url}">${item.product_title}</a>
          <div class="card__ship">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="card__price"><span class="card__now">${money(item.final_line_price)}</span></div>
          <button class="card__ship" type="button" data-cart-remove="${item.key}" style="border:0;background:none;padding:0;text-decoration:underline">Remove</button>
        </div>
        <div>x${item.quantity}</div>
      </div>`).join('');

    drawerBody.innerHTML = `
      ${lines}
      <div class="cart-total"><span>Subtotal</span><span>${money(cart.total_price)}</span></div>
      <a class="btn btn--primary btn--block" href="${window.routes.cart_url}">View cart</a>
      <form action="${window.routes.cart_url}" method="post" style="margin-top:10px">
        <button class="btn btn--outline btn--block" type="submit" name="checkout">Checkout</button>
      </form>`;
  };

  const openDrawer = () => { if (drawer) drawer.hidden = false; };
  document.querySelectorAll('[data-cart-close]').forEach((b) =>
    b.addEventListener('click', () => drawer && (drawer.hidden = true))
  );

  const refreshCart = () =>
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));
        renderCart(cart);
        return cart;
      });

  document.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 })
    }).then(refreshCart);
  });

  /* ------------------------------------------------------- ajax add-to-cart */
  document.querySelectorAll('form[data-ajax-cart]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const label = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = 'Adding…'; }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then((r) => r.json())
        .then(() => refreshCart())
        .then(() => openDrawer())
        .catch(() => form.submit())
        .finally(() => {
          if (button) { button.disabled = false; button.textContent = label; }
        });
    });
  });

  /* ------------------------------------------------------- product gallery */
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (main) main.src = thumb.dataset.galleryThumb;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  /* ------------------------------------------------------- variant picker */
  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const variants = JSON.parse(picker.querySelector('[data-variant-json]').textContent);
    const idInput = picker.querySelector('[name="id"]');
    const priceEl = picker.querySelector('[data-variant-price]');
    const submit = picker.querySelector('[type="submit"]');

    picker.querySelectorAll('select[data-option-index]').forEach((select) => {
      select.addEventListener('change', () => {
        const chosen = Array.from(picker.querySelectorAll('select[data-option-index]')).map((s) => s.value);
        const match = variants.find((v) => chosen.every((value, i) => v.options[i] === value));
        if (!match) return;
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? submit.dataset.addLabel : 'Sold out';
        }
      });
    });
  });

  /* ---------------------------------------------- cart page qty auto submit */
  document.querySelectorAll('[data-cart-qty]').forEach((input) => {
    input.addEventListener('change', () => input.closest('form').submit());
  });
})();
